import { ISrcSetSize } from 'Components/ProductCard/ProductCardImage';

export const getAspectRatioStyles = (
    srcSetSizes: ISrcSetSize
): React.CSSProperties =>
    Object.keys(srcSetSizes).reduce((acc, key) => {
        const sizeKey = key as keyof ISrcSetSize;
        const { width, height } = srcSetSizes[sizeKey];
        acc[`--aspect-ratio-${key}`] = `${width}/${height}`;
        return acc;
    }, {} as React.CSSProperties);
